module.exports = __webpack_public_path__ + "img/main-fiction.3530f49f.jpg";